<template>
    <div>
            <form action="">
                <div class="">
                    <header class="">
                        <p class="is-size-1 has-text-centered has-text-white">Update Spare Part: {{ number }}</p>
                    </header>
                    <section class="has-background-dvodark">
                            <div class="columns is-centered">
                                <div class="column is-6">
                            <b-field label="Description">
                                <b-input
                                    type="text"
                                    v-model="description"
                                    placeholder="Enter a description"
                                    required>
                                </b-input>
                            </b-field>
                            <b-field label="MSRP">
                                <b-input
                                    type="text"
                                    v-model="msrp"
                                    placeholder="Enter the msrp"
                                    required>
                                </b-input>
                            </b-field>
                            <b-field label="Manufacture Cost">
                                <b-input
                                    type="text"
                                    v-model="manufacture_cost"
                                    placeholder="Enter the manufacture cost"
                                    required>
                                </b-input>
                            </b-field>
                            <b-field label="Distributor Cost">
                                <b-input
                                    type="text"
                                    v-model="distributor_cost"
                                    placeholder="Enter the distributor cost"
                                    required>
                                </b-input>
                            </b-field>
                            <b-field label="Dealer Cost">
                                <b-input
                                    type="text"
                                    v-model="dealer_cost"
                                    placeholder="Enter the dealer cost"
                                    required>
                                </b-input>
                            </b-field>
                            </div>
                        </div>
                    </section>
                    <section class="section">
                    <footer class="has-text-centered">
                        <b-button class="is-dvogreen" @click="updatePart()">Update Part</b-button>
                    </footer>
                    </section>

                </div>
            </form>
    </div>
</template>

<script>
import { API } from 'aws-amplify';
import { updatePart } from '../../graphql/mutations'
export default {
    data(){
    return{
        number: this.initNumber,
        description: this.initDescription,
        distributor_cost: this.initDistributorCost,
        dealer_cost: this.initDealerCost,
        manufacture_cost: this.initManufactureCost,
        msrp: this.initMsrp,
        }
    },
    props: ['initNumber' , 'initDescription', 'initDistributorCost', 'initDealerCost', 'initManufactureCost', 'initMsrp'],
    methods:{
    async updatePart() {
    // const frog = {
    //           number: this.number,
    //           description: this.description,
    //           distributor_cost: this.distributor_cost,
    //           dealer_cost: this.dealer_cost,
    //           manufacture_cost: this.manufacture_cost,
    //           msrp: this.msrp
    // }
    const temporaryStorage = await API.graphql({
      query: updatePart,
      variables: {
          input: {
              number: this.number,
              description: this.description,
              distributor_cost: this.distributor_cost,
              dealer_cost: this.dealer_cost,
              manufacture_cost: this.manufacture_cost,
              msrp: this.msrp
          }
      },
    });
    const valToPass = temporaryStorage.data.updatePart
    this.$emit('close', valToPass);
    }
}}
</script>
